import { Dispatch as ReactDispatch, SetStateAction } from 'react'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { auth } from 'firebase/index'
import axios from 'axios'
import { INVITE_STAFF_ENDPOINT } from 'constants/urls'
import { push } from 'connected-react-router'

const inviteOwners = (emails: string[], storeId: string, setErrors: ReactDispatch<SetStateAction<string[]>>) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    // トークンを再取得する
    const token = await auth.currentUser?.getIdToken()
    if (typeof !token === 'undefined') {
      console.error('認証トークンの取得に失敗しました。')
      return
    }
    const role = 9
    const store_ids = [storeId]
    let flag = true
    for (let i = 0; i < emails.length; i = (i + 1) | 0) {
      const email = emails[i]
      try {
        await axios.post(
          INVITE_STAFF_ENDPOINT,
          { email, role, store_ids },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
      } catch (e) {
        setErrors((prevState) => {
          const nextState = prevState
          if (axios.isAxiosError(e)) {
            nextState[i] = e.response?.data.status === 'warning' ? e.response?.data.message : '招待に失敗しました。'
            return [...nextState]
          } else {
            console.error(e)
            return prevState
          }
        })
        flag = false
      }
    }
    dispatch(hideLoadingAction())
    if (!flag) return
    dispatch(push(`/admin/shops/create/complete`))
  }
}

export default inviteOwners
